import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col max-md:mt-8" }
const _hoisted_2 = { class: "flex justify-between items-center mb-4" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = { class: "flex flex-col gap-4 mb-6 text-left" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_TemplateSelector = _resolveComponent("TemplateSelector")!
  const _component_CardStyling = _resolveComponent("CardStyling")!
  const _component_DirectoryHeaderDesign = _resolveComponent("DirectoryHeaderDesign")!
  const _component_ExpertSelector = _resolveComponent("ExpertSelector")!
  const _component_SearchFiltersToggle = _resolveComponent("SearchFiltersToggle")!
  const _component_WebsiteUrl = _resolveComponent("WebsiteUrl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Edit Layout Settings", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "text-black border p-2 rounded-lg border-gray-300 font-inter text-sm font-medium",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createTextVNode(" Close ")
          ])),
          _: 1
        }),
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "bg-primary-purple text-white p-2 rounded-lg font-inter text-sm font-medium",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update', _ctx.layout))),
          disabled: _ctx.updateDirectoryLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.updateDirectoryLoading ? "Updating..." : "Update"), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-2" }, " Layout Name ", -1)),
        _createElementVNode("input", {
          value: _ctx.layout.layoutName || '',
          onInput: _cache[2] || (_cache[2] = (event) => _ctx.$emit('updateLayoutName', _ctx.layout.id, (event.target as HTMLInputElement).value)),
          placeholder: "Enter layout name",
          class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-purple focus:border-transparent"
        }, null, 40, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[27] || (_cache[27] = _createElementVNode("label", { class: "text-sm font-medium text-gray-700 mb-2" }, " Layout Type ", -1)),
        _createElementVNode("select", {
          value: _ctx.layout.layoutType || 'grid',
          onChange: _cache[3] || (_cache[3] = (event) => _ctx.$emit('updateLayoutType', _ctx.layout.id, (event.target as HTMLSelectElement).value)),
          class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-purple focus:border-transparent"
        }, _cache[26] || (_cache[26] = [
          _createElementVNode("option", { value: "grid" }, "Grid", -1),
          _createElementVNode("option", { value: "single" }, "Single", -1),
          _createElementVNode("option", { value: "row" }, "Row", -1)
        ]), 40, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_TemplateSelector, {
        initialSelected: _ctx.layout.style,
        onTemplateSelected: _cache[4] || (_cache[4] = 
          (template) => _ctx.$emit('updateLayoutStyle', _ctx.layout.id, template)
        )
      }, null, 8, ["initialSelected"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_CardStyling, {
        fontFamily: _ctx.layout.directoryCosmetic.fontFamily,
        fontSize: _ctx.layout.directoryCosmetic.fontSize,
        buttonTextColor: _ctx.layout.directoryCosmetic.textColor,
        boldness: _ctx.layout.directoryCosmetic.bold,
        buttonBackgroundColor: _ctx.layout.directoryCosmetic.backgroundColor,
        onFontFamilyChanged: _cache[5] || (_cache[5] = 
          (font) => _ctx.$emit('updateLayoutCosmetic', _ctx.layout.id, 'fontFamily', font)
        ),
        onBoldnessChanged: _cache[6] || (_cache[6] = 
          (bold) => _ctx.$emit('updateLayoutCosmetic', _ctx.layout.id, 'bold', bold)
        ),
        onButtonTextColorChanged: _cache[7] || (_cache[7] = 
          (color) => _ctx.$emit('updateLayoutCosmetic', _ctx.layout.id, 'textColor', color)
        ),
        onButtonBackgroundColorChanged: _cache[8] || (_cache[8] = 
          (color) => _ctx.$emit('updateLayoutCosmetic', _ctx.layout.id, 'backgroundColor', color)
        ),
        onFontSizeChanged: _cache[9] || (_cache[9] = 
          (size) => _ctx.$emit('updateLayoutCosmetic', _ctx.layout.id, 'fontSize', size)
        )
      }, null, 8, ["fontFamily", "fontSize", "buttonTextColor", "boldness", "buttonBackgroundColor"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_DirectoryHeaderDesign, {
        isVisible: _ctx.layout.directoryHeaderCosmetic.isVisible,
        fontFamily: _ctx.layout.directoryHeaderCosmetic.fontFamily,
        headerFontSize: _ctx.layout.directoryHeaderCosmetic.headerFontSize,
        paragraphFontSize: _ctx.layout.directoryHeaderCosmetic.paragraphFontSize,
        headerTextColor: _ctx.layout.directoryHeaderCosmetic.textColor,
        boldness: _ctx.layout.directoryHeaderCosmetic.bold,
        backgroundColor: _ctx.layout.directoryHeaderCosmetic.backgroundColor,
        headlineText: _ctx.layout.directoryHeaderCosmetic.headerText,
        paragraphText: _ctx.layout.directoryHeaderCosmetic.paragraphText,
        onParagraphTextChanged: _cache[10] || (_cache[10] = 
          (text) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'paragraphText', text)
        ),
        onFontFamilyChanged: _cache[11] || (_cache[11] = 
          (font) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'fontFamily', font)
        ),
        onBoldnessChanged: _cache[12] || (_cache[12] = 
          (bold) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'bold', bold)
        ),
        onTextColorChanged: _cache[13] || (_cache[13] = 
          (color) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'textColor', color)
        ),
        onBackgroundColorChanged: _cache[14] || (_cache[14] = 
          (color) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'backgroundColor', color)
        ),
        onHeaderFontSizeChanged: _cache[15] || (_cache[15] = 
          (size) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'headerFontSize', size)
        ),
        onParagraphFontSizeChanged: _cache[16] || (_cache[16] = 
          (size) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'paragraphFontSize', size)
        ),
        onHeadlineTextChanged: _cache[17] || (_cache[17] = 
          (text) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'headerText', text)
        ),
        onToggleVisibilityHeader: _cache[18] || (_cache[18] = 
          (visible) => _ctx.$emit('updateLayoutHeader', _ctx.layout.id, 'isVisible', visible)
        )
      }, null, 8, ["isVisible", "fontFamily", "headerFontSize", "paragraphFontSize", "headerTextColor", "boldness", "backgroundColor", "headlineText", "paragraphText"])
    ]),
    (_ctx.layout.layoutType === 'single' || _ctx.layout.layoutType === 'row')
      ? (_openBlock(), _createBlock(_component_ExpertSelector, {
          key: 0,
          approvedExperts: _ctx.getAvailableExperts(_ctx.layout),
          selectedExpertIds: _ctx.layout.selectedExpertIds || [],
          layoutType: _ctx.layout.layoutType,
          selectRandomExperts: _ctx.layout.selectRandomExperts || false,
          layoutId: _ctx.layout.id,
          fieldErrors: _ctx.fieldErrors,
          onExpertChanged: _cache[19] || (_cache[19] = 
        (ids, fieldIndex) =>
          _ctx.$emit('updateLayoutSelectedExperts', _ctx.layout.id, ids, fieldIndex)
      ),
          onRandomModeChanged: _cache[20] || (_cache[20] = 
        (isRandom) => _ctx.$emit('updateLayoutRandomExperts', _ctx.layout.id, isRandom)
      )
        }, null, 8, ["approvedExperts", "selectedExpertIds", "layoutType", "selectRandomExperts", "layoutId", "fieldErrors"]))
      : _createCommentVNode("", true),
    (_ctx.layout.layoutType === 'grid')
      ? (_openBlock(), _createBlock(_component_SearchFiltersToggle, {
          key: 1,
          showSearchFilters: _ctx.layout.showSearchFilters,
          onSearchFiltersChanged: _cache[21] || (_cache[21] = 
        (enabled) => _ctx.$emit('updateLayoutSearchFilters', _ctx.layout.id, enabled)
      )
        }, null, 8, ["showSearchFilters"]))
      : _createCommentVNode("", true),
    _createVNode(_component_WebsiteUrl, {
      websiteUrl: _ctx.layout.websiteUrl,
      companyWebsite: _ctx.userStore.companyWebsite || '',
      onWebsiteUrlChanged: _cache[22] || (_cache[22] = (url) => _ctx.$emit('updateLayoutWebsite', _ctx.layout.id, url))
    }, null, 8, ["websiteUrl", "companyWebsite"])
  ]))
}